define('bindingHandlers/selectOptions',[
    'jquery',
    'lib/knockout',
    'lib/lodash4'
], function ($, ko,_) {
    'use strict';

    /**
     * This is a wrapper binding handler for an already built in knockout support for a select.
     * One of the things it is allowing us to do is improving upon some of the already existing
     * behaviors for a select control. First enhanced functionality added is the support of identifying and styling
     * of a placeholder entry.
     *
     * # Required Arguments
     *
     * @param {Object} object - An object containing any applicable select bindings
     *
     * Example:
     *
     *   <select  class="form-control" data-bind="selectOptions: {
     *           valueUpdate: 'input',
     *           value: observableVariable,
     *           valueAllowUnset: boolean,
     *           optionsText: propertyName,
     *           options: observableArray,
     *           optionsCaption: localizedText,
     *           disable: observableVariable
     *           }">
     *   </select>
     *
     */
    ko.bindingHandlers.selectOptions = {
        init: function (element, valueAccessor) {
            var SELECT_PLACEHOLDER = 'select-options-placeholder';
            //unwrap passed in ko option properties
            var properties = ko.unwrap(valueAccessor());

            var optionsAfterRenderMethod;

            //get a reference optionsAfterRender method
            if (properties.optionsAfterRender) {
                optionsAfterRenderMethod = _.bind(properties.optionsAfterRender);
                delete properties.optionsAfterRender;
            }

            var inspectSelectedOption = function () {
                var selectedOption = $(element).find(":selected");
                if (selectedOption.length > 0) {
                    if (!$(selectedOption[0]).hasClass(SELECT_PLACEHOLDER)) {
                        $(element).removeClass(SELECT_PLACEHOLDER);
                    }
                    else {
                        $(element).addClass(SELECT_PLACEHOLDER);
                    }
                }
            };

            var afterRenderMethod = function (option, item) {

                if (optionsAfterRenderMethod) {
                    optionsAfterRenderMethod(option, item);
                }
                //Check if an item is a placeholder node
                if (!item) {
                    ko.applyBindingsToNode(option, {disable: true}, item);
                    option.className = SELECT_PLACEHOLDER;
                    $(element).addClass(SELECT_PLACEHOLDER);
                }
            };

            properties.optionsAfterRender = afterRenderMethod;
            ko.applyBindingsToNode(element, properties);

            if (properties.value) {
                properties.value.subscribe(function () {
                    inspectSelectedOption();
                });
            }

            inspectSelectedOption();
        }
    };
});

